<template>
    <div>
        <LsNavbar />
        <div class="container">
            <RouterView />
        </div>
    </div>
</template>

<script>
import { LsNavbar } from '@/components/';

export default {
    name: 'GuestParentView',
    components: {
        LsNavbar,
    },
};
</script>
<style lang="scss" scoped>
/* override main.scss container media queries so content is always below navbar */
.container {
    padding-top: $navbar-height + 2rem;
}
</style>
